import { computed } from "mobx"
import { observer, useLocalObservable } from "mobx-react"

import { CreateButton } from "@src/app/components/CreateButton"
import { NoContent } from "@src/app/components/NoContent/Index"
import { configStore } from "@src/app/configStore"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import { InvoiceCollection } from "@src/pages/paymentLinks/classes/InvoiceCollection"
import { PaymentsLinksTable } from "@src/pages/paymentLinks/ui/PaymentsLinksTable"

export const PaymentLinksPage = observer(() => {
  const invoices = useLocalObservable(() => new InvoiceCollection())

  const {
    config: { payment_page_url },
    isLoading: configIsLoading,
  } = configStore

  const [isEmpty, isLoading] = computed(() => {
    return [
      invoices.generalEmpty,
      configIsLoading || (invoices.generalEmpty && invoices.isLoading),
    ]
  }).get()

  return (
    <DefaultPageLayout
      button={
        <CreateButton
          text="Create a payment link"
          to={paths.paymentLinksCreate}
        />
      }
      emptyBlock={
        <NoContent
          paragraph="This section will contain all the Payment Links you have created"
          title="No Payment Links Yet"
        />
      }
      isEmpty={isEmpty}
      isLoading={isLoading}
      title="Payment Links"
    >
      <PaymentsLinksTable
        collection={invoices}
        paymentPageUrl={payment_page_url}
      ></PaymentsLinksTable>
    </DefaultPageLayout>
  )
})
